import { render } from "./SettingsUsers.vue?vue&type=template&id=38e4faa4&scoped=true"
import script from "./SettingsUsers.vue?vue&type=script&lang=js"
export * from "./SettingsUsers.vue?vue&type=script&lang=js"

import "./SettingsUsers.vue?vue&type=style&index=0&id=38e4faa4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e4faa4"]])

export default __exports__